<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.report', 2) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <DateDialog
                  :label="$t('attrs.startDate')"
                  :defaultDate="startDate"
                  @onSelectDate="val => startDate = val"></DateDialog>
              </v-flex>

              <v-flex xs12 md4>
                <DateDialog
                  :label="$t('attrs.endDate')"
                  :defaultDate="endDate"
                  @onSelectDate="val => endDate = val"></DateDialog>
              </v-flex>
            </v-layout>

            <template v-if="$auth.isDev()">
              <h2>
                {{ $t('shipmentFilters') }}
              </h2>

              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-select v-model="provider"
                    :items="providers"
                    item-value="id"
                    item-text="name"
                    :label="$tc('models.provider')"
                    @change="showHideEsFilters"
                    ></v-select>
                </v-flex>

                <v-flex xs12 md4>
                  <v-select v-model="status"
                    :items="statuses"
                    item-value="id"
                    item-text="name"
                    :label="$tc('attrs.status')"
                    ></v-select>
                </v-flex>

                <template v-if="estafetaFiltersVisible">
                  <v-flex xs12 md12>
                    <h3>{{ $t('estafetaFilters') }}</h3>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-text-field v-model="estafetaRange"
                      name="estafeta_range"
                      :label="$t('estafetaRange')"
                      v-validate="'digits:3'"
                      :error-messages="errors.collect('estafetaRange')"
                      data-vv-name="estafetaRange"
                      :data-vv-as="$t('estafetaRange')"
                      ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-text-field v-model="estafetaAccount"
                      name="estafeta_account"
                      :label="$t('estafetaAccount')"
                      v-validate="'digits:7'"
                      :error-messages="errors.collect('estafetaAccount')"
                      data-vv-name="estafetaAccount"
                      :data-vv-as="$t('estafetaAccount')"
                      ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-text-field v-model="estafetaAgent"
                      name="estafeta_agent"
                      :label="$t('estafetaAgent')"
                      v-validate="'digits:3'"
                      :error-messages="errors.collect('estafetaAgent')"
                      data-vv-name="estafetaAgent"
                      :data-vv-as="$t('estafetaAgent')"
                      ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-text-field v-model="estafetaShippingNumber"
                      name="estafeta_shipping_number"
                      :label="$t('estafetaShippingNumber')"
                      v-validate="'min:4'"
                      :error-messages="errors.collect('estafetaShippingNumber')"
                      data-vv-name="estafetaShippingNumber"
                      :data-vv-as="$t('estafetaShippingNumber')"
                      ></v-text-field>
                  </v-flex>
                </template>

                <v-flex xs12 md6>
                  <v-checkbox v-model="allShipments" :label="$t('includeAllShipments')"></v-checkbox>
                </v-flex>
              </v-layout>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>

      <template v-for="report in items">
        <v-flex xs12 v-if="report.visible || $auth.isDev()" :key="report.id">
          <v-card>
            <v-list>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title> {{ $tc(`models.${report.name}`, 2) }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn color="primary" outline :disabled="loading || ifDisabled(report.name)" @click="download(report.name)"> {{ $t('download') }} </v-btn>
                </v-list-tile-action>

              </v-list-tile>
              <v-flex v-if="$auth.isDev()" class="pt-0 pb-0">
                <v-checkbox class="mt-0" v-model="report.visible" :label="'Visible'" @change="setVisible(report)"></v-checkbox>
              </v-flex>
            </v-list>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

import { getDaysAgo, formatDate } from '@/utils.js'

import Enum from '@/client/enum'
import Report from '@/client/report'
import Provider from '@/client/provider'

import Carrier from '@/client/carrier'
import Shipment from '@/client/shipment'
import User from '@/client/user'
import FiscalDatum from '@/client/fiscal-datum'
import Transaction from '@/client/transaction'
import CarrierSetting from '@/client/carrier-setting'
import Overweight from '@/client/overweight'
import Invoice from '@/client/invoice'

export default {
  name: 'ReportsView',

  props: {},

  data () {
    return {
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      items:[],
      providers: [],
      enums: {},
      statuses: [],
      status: '',
      provider: '',
      allShipments: false,
      estafetaRange: '',
      estafetaAccount: '',
      estafetaAgent: '',
      estafetaShippingNumber: '',
      estafetaFiltersVisible: false,
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {

    handleBlobErr (err) {
      const self = this
      if (err.response) {
        const blob = err.response.data
        const reader = new FileReader()

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          self.handleErr({ response: { data: JSON.parse(text) } })
        })

        // Start reading the blob as text.
        reader.readAsText(blob)
      } else {
        this.handleErr(err)
      }
    },

    downloadFile (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    async downloadCarriersReport () {
      this.loading = true
      try {
        const data = await Carrier.export({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.carrier', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadShipmentsReport () {
      this.loading = true
      try {
        const data = await Shipment.export({
          start_date: this.startDate,
          end_date: this.endDate,
          status: this.status,
          provider: this.provider,
          all_shipments: this.allShipments,
          estafeta_range: this.estafetaRange,
          estafeta_account: this.estafetaAccount,
          estafeta_agent: this.estafetaAgent,
          estafeta_shipping_number: this.estafetaShippingNumber
        })
        this.downloadFile(data, `${this.$tc('models.shipment', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadUsersReport () {
      this.loading = true
      try {
        const data = await User.export({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.user', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadFiscalDataReport () {
      this.loading = true
      try {
        const data = await FiscalDatum.export()
        this.downloadFile(data, `${this.$tc('models.fiscalDatum', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadTransactionsReport () {
      this.loading = true
      try {
        const data = await Transaction.export({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.transaction', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadCarrierSettingLogsReport () {
      this.loading = true
      try {
        const data = await CarrierSetting.exportLimitLogs({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.carrierSettingLog', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadOverweightsReport () {
      this.loading = true
      try {
        const data = await Overweight.export({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.overweight', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadInvoicesReport () {
      this.loading = true
      try {
        const data = await Invoice.export({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.invoice', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async downloadInsurancesReport () {
      this.loading = true
      try {
        const data = await Report.insurance({
          start_date: this.startDate,
          end_date: this.endDate
        })
        this.downloadFile(data, `${this.$tc('models.insurance', 2)}.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
      this.loading = false
    },

    async fetch () {
      this.items = await Report.all({
        per_page: 2000
      })
    },

    download (name) {
      name = name === 'fiscalDatum' ? 'fiscalData' : `${name}s`;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      this[`download${ name }Report`]();
    },

    async setVisible (report) {
      try {
        await report.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
      } catch (err) {
        this.handleErr(err)
      }
    },

    setStatuses () {
      this.statuses = [
        { id: '', name: this.$t('all') }
      ]
      if (!this.enums.shipments_status) { return this.statuses }

      for (let k in this.enums.shipments_status) {
        if (k == 'pending') continue
        this.statuses.push({ id: k, name: this.$t('list.statuses.' + k) })
      }
    },

    showHideEsFilters () {
      if (this.isProviderEstafeta()) {
        this.estafetaFiltersVisible = true
      }else {
        this.estafetaFiltersVisible = false
        this.estafetaRange = ''
        this.estafetaAccount = ''
        this.estafetaAgent = ''
        this.estafetaShippingNumber = ''
      }
    },

    isProviderEstafeta () {
      return this.providers.find( p => p.id == this.provider )['code'] === 'Estafeta'
    },

    ifDisabled (name) {
     return (name == 'carrierSettingLog' && !this.$auth.isDev() && !this.$auth.isMainAdmin()) ? true : false
    }
  },

  watch: {
  },

  async mounted () {
    if (!this.$auth.isDev()){
      const reportLimit = await Report.reportLimit()
      this.startDate = formatDate( getDaysAgo(reportLimit) )
      this.endDate = formatDate( new Date() )
    }

    this.providers = await Provider.all()
    this.providers.unshift( {id: '', name: this.$t('all')} )

    this.enums = await Enum.all()
    this.setStatuses()
    // console.log('p', this.providers, this.statuses)

    this.fetch()
  }
}
</script>
